import React from 'react';
import PayzenCashoutDetails from 'app/components/cashout/PayzenCashoutDetails';
import FieldWrapInput from 'app/components/cashout/FieldWrapInput';

export default class IndiaPayTmDetails extends PayzenCashoutDetails {
    state = {
        bank_account_number: ''
    };

    render() {
        const {disabled, errors} = this.props;

        return <div className="cashout__field field">
            <FieldWrapInput
                stateName="bank_account_number"
                handleOnChange={this.handleOnChange}
                value={this.state.bank_account_number}
                disabled={disabled}
                errors={errors}
            />
        </div>;
    }
}
